(function () {
  "use strict";

  /* ========== CURRENCY HELPERS ========== */
  var ZERO_DEC = ["JPY", "KRW", "VND", "CLP", "ISK"];

  function activeCurrency() {
    if (
      window.Shopify &&
      Shopify.currency &&
      (Shopify.currency.active || Shopify.currency.current)
    )
      return String(
        Shopify.currency.active || Shopify.currency.current,
      ).toUpperCase();
    if (window.theme && theme.currency)
      return String(theme.currency).toUpperCase();
    var c =
      document.documentElement &&
      document.documentElement.dataset &&
      document.documentElement.dataset.currency;
    if (c) return String(c).toUpperCase();
    return (window.shopCurrency || "USD").toUpperCase();
  }

  function parseMoney(text) {
    if (!text) return 0;
    var cur = activeCurrency();
    var cleaned = text.replace(/^[^\d]+/, "").trim();
    cleaned = cleaned.replace(/[^\d,\.]+.*$/, "").trim();
    if (!cleaned) return 0;
    var hasComma = cleaned.indexOf(",") > -1;
    var hasDot = cleaned.indexOf(".") > -1;
    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(",") > cleaned.lastIndexOf(".")) {
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (hasComma && !hasDot) {
      cleaned =
        cleaned.split(",").pop().length === 2
          ? cleaned.replace(",", ".")
          : cleaned.replace(/,/g, "");
    }
    if (ZERO_DEC.indexOf(cur) > -1) return Math.round(parseFloat(cleaned)) || 0;
    return Math.round(parseFloat(cleaned) * 100) || 0;
  }

  function formatCents(cents) {
    var fmt =
      (window.theme &&
        theme.settings &&
        theme.settings.money_with_currency_format) ||
      (window.Shopify && Shopify.money_format) ||
      "${{amount}}";
    var fn = window.formatMoney || (window.Shopify && Shopify.formatMoney);
    if (typeof fn === "function") {
      try {
        return fn(cents, fmt);
      } catch (e) {}
    }
    return (cents / 100).toFixed(2);
  }

  var popupBg,
    popupCont,
    popupCloseBtn,
    popupTitleEl,
    popupSaleEl,
    popupCmpEl,
    popupSaveEl,
    popupDescEl,
    popupGalleryEl;

  function buildPopupOverlay() {
    if (document.getElementById("tmx-upsell-prod-popup-cont")) return; // already built

    var bgEl = document.createElement("div");
    bgEl.id = "tmx-upsell-prod-popup-bg";
    bgEl.className = "tmx-upsell-prod-popup-bg";

    var contEl = document.createElement("div");
    contEl.id = "tmx-upsell-prod-popup-cont";
    contEl.className = "tmx-upsell-prod-popup-cont";
    contEl.setAttribute("role", "dialog");
    contEl.setAttribute("aria-modal", "true");
    contEl.setAttribute("aria-label", "Product preview");

    contEl.innerHTML =
      '<div class="tmx-upsell-prod-popup-body">' +
      '<div class="tmx-upsell-prod-popup-header">' +
      '<button class="tmx-upsell-prod-popup-close" id="tmx-upsell-prod-popup-close" aria-label="Close">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none">' +
      '<path d="M19 5L5 19" stroke="#333" stroke-width="3" stroke-linecap="round"/>' +
      '<path d="M5 5L19 19" stroke="#333" stroke-width="3" stroke-linecap="round"/>' +
      "</svg>" +
      "</button>" +
      "</div>" +
      '<div class="tmx-upsell-prod-popup-body-cont tmx-upsell-prod-prev-body-cont-height">' +
      '<div class="tmx-upsell-prod-popup-img-wrap">' +
      '<div class="tmx-upsell-prod-popup-gallery" id="tmx-upsell-prod-popup-gallery"></div>' +
      "</div>" +
      '<div class="tmx-upsell-prod-popup-title" id="tmx-upsell-prod-popup-title"></div>' +
      '<div class="tmx-upsell-prod-popup-price-cont">' +
      '<span class="tmx-upsell-prod-popup-sale" id="tmx-upsell-prod-popup-sale"></span>' +
      '<span class="tmx-upsell-prod-popup-compare" id="tmx-upsell-prod-popup-compare"></span>' +
      '<span class="badge price__badge-sale" id="tmx-upsell-prod-popup-save"></span>' +
      "</div>" +
      '<div class="tmx-upsell-prod-popup-desc" id="tmx-upsell-prod-popup-desc"></div>' +
      // '<div class="tmx-upsell-prod-popup-view-more">' +
      // '<a href="#" id="tmx-upsell-prod-popup-link" class="tmx-upsell-prod-popup-view-more-btn" target="_blank">' +
      // "<span>View more details</span>" +
      // '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      // "<g>" +
      // '<polyline points="16.4 7 21.5 12 16.4 17" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></polyline>' +
      // '<line x1="2.5" y1="12" x2="19.2" y2="12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>' +
      // "</g>" +
      // "</svg>" +
      // "</a>" +
      // "</div>" +
      "</div>" +
      "</div>";

    document.body.appendChild(bgEl);
    document.body.appendChild(contEl);

    popupBg = bgEl;
    popupCont = contEl;
    popupCloseBtn = contEl.querySelector("#tmx-upsell-prod-popup-close");
    popupTitleEl = contEl.querySelector("#tmx-upsell-prod-popup-title");
    popupSaleEl = contEl.querySelector("#tmx-upsell-prod-popup-sale");
    popupCmpEl = contEl.querySelector("#tmx-upsell-prod-popup-compare");
    popupSaveEl = contEl.querySelector("#tmx-upsell-prod-popup-save");
    popupDescEl = contEl.querySelector("#tmx-upsell-prod-popup-desc");
    // popupLinkEl = contEl.querySelector("#tmx-upsell-prod-popup-link");
    popupGalleryEl = contEl.querySelector("#tmx-upsell-prod-popup-gallery");

    popupCloseBtn.addEventListener("click", closePopup);
    popupBg.addEventListener("click", closePopup);
  }

  function openPopup(dataEl) {
    if (!dataEl) return;
    buildPopupOverlay(); // no-op if already built

    popupTitleEl.textContent = dataEl.dataset.title || "";
    popupSaleEl.textContent = dataEl.dataset.sale || "";
    popupCmpEl.textContent = dataEl.dataset.compare || "";
    popupCmpEl.style.display = dataEl.dataset.compare ? "" : "none";
    popupSaveEl.textContent = dataEl.dataset.save || "";
    popupSaveEl.style.display = dataEl.dataset.save ? "" : "none";

    // Clone + initialize the heavy markup only on first open per product.
    // Subsequent opens reuse the cached, already-initialized nodes.
    if (!dataEl._tmxCloned) {
      var tpl = dataEl.querySelector(".tmx-upsell-popup-template");
      if (tpl && tpl.content) {
        dataEl.appendChild(tpl.content.cloneNode(true));
      }
      dataEl._tmxCloned = true;
    }

    var gallerySource = dataEl.querySelector(
      ".tmx-upsell-popup-gallery-source",
    );
    var descSource = dataEl.querySelector(".tmx-upsell-popup-description");

    popupGalleryEl.innerHTML = "";
    if (gallerySource && gallerySource.firstElementChild) {
      popupGalleryEl.appendChild(
        gallerySource.firstElementChild.cloneNode(true),
      );
    }

    popupDescEl.innerHTML = descSource ? descSource.innerHTML : "";

    var mediaGallery = popupGalleryEl.querySelector("media-gallery");
    if (mediaGallery && typeof mediaGallery.initialize === "function") {
      mediaGallery.initialize();
    }

    // popupLinkEl.href = dataEl.dataset.url || "#";

    popupBg.style.display = "block";
    popupCont.style.display = "block";
    document.body.style.overflow = "hidden";
  }

  function closePopup() {
    if (!popupBg || !popupCont) return;
    popupBg.style.display = "none";
    popupCont.style.display = "none";
    document.body.style.overflow = "";
  }

  // Delegated on document — survives every AJAX re-render of the section,
  // since new .tmx-upsell-popup-trigger elements are matched automatically
  // and the matching data-island is looked up fresh (by ID) at click time.
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".tmx-upsell-popup-trigger");
    if (!trigger) return;
    e.preventDefault();

    var popupId = trigger.dataset.popup;
    var dataEl = popupId ? document.getElementById(popupId) : null;
    openPopup(dataEl);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePopup();
  });
  /* Start ADD-ON CARD — orange design + whole-card click-to-select - 23-07-2026  */
  document.addEventListener("click", function (e) {
    var card = e.target.closest("[data-addon-card]");
    if (!card) return;

    // Let "View details" open the popup instead of toggling selection.
    if (e.target.closest(".tmx-addons__view-details")) return;

    var checkbox = card.querySelector(".tmx-addons__checkbox");
    if (!checkbox || checkbox.disabled) return;

    // Native click on the (visually hidden) checkbox/label already toggles
    // it and fires 'change' on its own — don't double-toggle in that case.
    if (e.target.closest(".tmx-addons__checkbox-label")) return;

    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  });
  /* End ADD-ON CARD — orange design + whole-card click-to-select  - 23-07-2026 */
  /* ===============================
    CUSTOM UPSELL PRICE
  ================================*/

  // The ATC button and price are replaced on variant change / color swap,
  // so always look them up fresh instead of caching them in a closure.
  function getAtcBtn() {
    return document.querySelector(".product-form__submit");
  }

  function getAtcLabel(atcBtn) {
    return atcBtn.querySelector("span") || atcBtn;
  }

  function getBasePrice() {
    const el = document.querySelector(
      ".product__info-container .price .price-item--sale, " +
        ".product__info-container .price .price-item--regular",
    );
    return el ? parseMoney(el.textContent) : 0;
  }

  function getAddonPrice() {
    let total = 0;
    document.querySelectorAll(".tmx-addons__checkbox:checked").forEach(function (cb) {
      total += Number(cb.dataset.priceCents || 0);
    });

    // Include A/B "variation" qty-stepper add-ons
    document.querySelectorAll("[data-addon-var-card]").forEach(function (card) {
      const qtyInput = card.querySelector(".tmx-addon-var__line-qty");
      const qty = qtyInput ? Number(qtyInput.value || 0) : 0;
      if (qty > 0) {
        const priceCents = Number(card.querySelector(".tmx-addon-var__actions")?.dataset.priceCents || 0);
        total += priceCents * qty;
      }
    });

    return total;
  }

  function updateButtonPrice() {
    const atcBtn = getAtcBtn();
    if (!atcBtn) return;
    const label = getAtcLabel(atcBtn);
    const text = label.textContent.split("•")[0].trim();

    // Sold out / unavailable — leave the theme's text alone.
    if (atcBtn.hasAttribute("disabled")) {
      label.textContent = text;
      atcBtn.classList.remove("tmx-atc-has-addons");
      return;
    }

    const addon = getAddonPrice();
    label.textContent = text + " • " + formatCents(getBasePrice() + addon);
    atcBtn.classList.toggle("tmx-atc-has-addons", addon > 0);
  }

  function resetButton() {
    document.querySelectorAll(".tmx-addons__checkbox").forEach(function (cb) {
      cb.checked = false;
      const card = cb.closest(".tmx-addons__card");
      if (card) card.classList.remove("is-selected");
    });
    document.querySelectorAll(".custom-name-item").forEach(function (input) {
      input.disabled = true;
    });
    window.tmxResetAddonVariationCards && window.tmxResetAddonVariationCards();
    updateButtonPrice();
  }

  // Checkbox change (delegated — registered once, survives re-renders)
  document.addEventListener("change", function (e) {
    if (e.target.matches(".tmx-addons__checkbox")) {
      const card = e.target.closest(".tmx-addons__card");
      const hiddenInput = card?.querySelector(".custom-name-item");
      if (hiddenInput) hiddenInput.disabled = !e.target.checked;
      if (card) card.classList.toggle("is-selected", e.target.checked);
    }
    if (e.target.matches(".tmx-addons__checkbox") || e.target.matches(".tmx-addon-var__line-qty")) {
      updateButtonPrice();
    }
  });

  // After Add to Cart (delegated submit on the main product form)
  document.addEventListener("submit", function (e) {
    const atcBtn = getAtcBtn();
    if (atcBtn && e.target === atcBtn.closest("form")) {
      setTimeout(resetButton, 1200);
    }
  });

  function initCustomUpsellPrice() {
    updateButtonPrice();

    // Size/variant change: theme.js toggleAddButton() resets the label to
    // plain "Add to cart" and then publishes variantChange — re-add price.
    if (
      !window._tmxVariantSub &&
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      window._tmxVariantSub = subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(updateButtonPrice, 0);
      });
    }
  }
  document.addEventListener("DOMContentLoaded", initCustomUpsellPrice);
  document.addEventListener("tmx:reinit", initCustomUpsellPrice);

   /* ============================================================
   ADD-ON CARD — VARIATION (A/B challenger) — qty stepper logic
   Fully separate from initCustomUpsellPrice/checkbox logic above.
   Delegated on document so it survives Section Rendering API re-renders,
   same pattern as the popup trigger.
   ============================================================ */
  function setQty(card, qty) {
    qty = Math.max(0, Math.min(99, qty));

    var addBtn = card.querySelector("[data-addon-var-add]");
    var qtyWrap = card.querySelector("[data-addon-var-qty]");
    var countEl = card.querySelector("[data-addon-var-count]");
    var qtyInput = card.querySelector(".tmx-addon-var__line-qty");
    var idInput = card.querySelector(".tmx-addon-var__line-id"); // NEW

    var selected = qty > 0;

    card.classList.toggle("is-selected", selected);

    if (addBtn) addBtn.hidden = selected;
    if (qtyWrap) qtyWrap.hidden = !selected;
    if (countEl) countEl.textContent = qty;

    if (qtyInput) {
      qtyInput.value = qty;
      qtyInput.disabled = !selected;
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (idInput) {
      idInput.disabled = !selected;
    }
  }

  function getQty(card) {
    var qtyInput = card.querySelector(".tmx-addon-var__line-qty");
    return qtyInput ? Number(qtyInput.value || 0) : 0;
  }

  document.addEventListener("click", function (e) {
    var addBtn = e.target.closest("[data-addon-var-add]");
    var plusBtn = e.target.closest("[data-addon-var-plus]");
    var removeBtn = e.target.closest("[data-addon-var-remove]");
    if (!addBtn && !plusBtn && !removeBtn) return;

    var card = e.target.closest("[data-addon-var-card]");
    if (!card) return;

    e.preventDefault();

    if (addBtn) setQty(card, 1);
    else if (plusBtn) setQty(card, getQty(card) + 1);
    else if (removeBtn) setQty(card, 0);
  });

  // Call this alongside resetButton() after ATC submit, or on 'tmx:reinit'.
  window.tmxResetAddonVariationCards = function () {
    document.querySelectorAll("[data-addon-var-card]").forEach(function (card) {
      setQty(card, 0);
    });
  };
  document.addEventListener("click", function (e) {
    var seeAllBtn = e.target.closest("[data-addon-see-all]");
    if (!seeAllBtn) return;

    var grid = seeAllBtn.closest("[data-addons-grid]");
    if (!grid) return;

    grid.querySelectorAll("[data-addon-extra]").forEach(function (wrap) {
      wrap.hidden = false;
      wrap.classList.add("tmx-addon-var__hidden-card--revealed");
    });

    seeAllBtn.remove();
  });

  function setEqualMaxHeight(selector) {
    const elements = document.querySelectorAll(selector);

    // Reset heights before measuring
    elements.forEach((element) => {
      element.style.height = "auto";
    });

    // Get maximum height
    let maxHeight = 0;

    elements.forEach((element) => {
      maxHeight = Math.max(maxHeight, element.offsetHeight);
    });

    // Apply maximum height to all elements
    elements.forEach((element) => {
      element.style.height = `${maxHeight}px`;
    });
  }

  // Run
  function runEqualHeight() {
    setEqualMaxHeight(".tmx-addons__card-v2 .tmx-addons__name");
  }

  // 1. First load
runEqualHeight();
window.addEventListener("load", runEqualHeight);

// 2. After every variant/swatch switch
// 2. Immediately after every variant/swatch switch (before the browser paints)
document.addEventListener("page:loaded", runEqualHeight);

// 3. Backup run for late changes (images, fonts)
document.addEventListener("tmx:reinit", runEqualHeight);

// 3. On window resize (same selector as above)
window.addEventListener("resize", runEqualHeight);
})();
